import script from "./FilesListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilesListItem.vue?vue&type=script&lang=ts&setup=true"

import "./FilesListItem.vue?vue&type=style&index=0&id=340aa16e&lang=scss&scoped=true"
import "./FilesListItem.vue?vue&type=style&index=1&id=340aa16e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340aa16e"]])

export default __exports__